const styleSheet = () => ({
  bodyBackground: {
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    boxShadow: (props: any) =>
      props.boxShadow ? props.boxShadow : '0 2px 4px 0 rgba(0,0,0,0.15)',
  },
  checkBoxHolder: {
    display: 'inline-block',
    marginRight: '16px',
    position: 'relative',
    zIndex: 1,
    top: '3px',
  },
  createdByHolder: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
  },
  createdByName: {
    maxWidth: '115px',
    wordBreak: 'break-all',
    lineHeight: '13px',
  },
  lock: {
    position: 'relative',
    width: '15px',
    float: 'right',
    left: '7px',
    top: '-2px',
  },
  firstCell: {
    textAlign: 'left',
    justifyContent: 'start',
    width: '100%',
    paddingLeft: '0px !important',
    // position: "relative",
    wordBreak: 'break-all',
  },
  firstCellBody: {
    width: '100%',
    textAlign: 'left',
    justifyContent: 'start',
    marginLeft: '0px !important',
    // position: "relative",
    wordBreak: 'break-all',
  },
  firstCellBodyAttributes: {
    display: 'flex',
  },
  attributeText: {
    height: '19px',
    width: '51px',
    color: '#000000',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 300,
    fontSize: '14px',
    fontHeight: '500',
    letterSpacing: 0,
    lineHeight: '19px',
  },
});

export default styleSheet;
